import { l } from '@utils/toolbox';

const tab = {
	id: '',
	selected: false,
	svgOnTab: false
};

/**
 * Kallebakom tabs
 * @param {tab[]} tabObjects [{ id: String, selected: Boolean }]
 * @returns html String
 */
export const tabs = (tabObjects) => {
	let html = `<div class="abTabNav abTabNav--kallebakom">`;

	tabObjects.forEach((tab) => {
		html += `<div class="abTabNav__btn ${tab.selected ? 'active' : ''}" data-kalletab="${tab.id}">
			${tab?.options?.svgOnTab
				? `<img class="kallebakom__tab--image" src="/static/v${js_params.version}/images/global/thirdparty_${tab.id}.svg" alt="${tab.id}" />`
				: `<span class="abTabNav__title">${l('kallebakom.' + tab.id + '.optionTitle')}</span>`
			}
			${tab?.options?.subtitleTab ? `<span class="kallebakom__tab--subtitle">${tab?.options?.subtitleTab}</span>` : ``}
		</div>`;
	});

	html += `</div>`;

	return html;
};
